import React, { useMemo, useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { Link } from 'react-router-dom';
import SectionAd from '../components/ads/SectionAd';
import FormattedNewsText from '../components/FormattedNewsText';


export default function NewsPage() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadActiveNews();
  }, []);

  const loadActiveNews = async () => {
    setLoading(true);
    try {
      const now = new Date();

      // Prendiamo TUTTE le news e filtriamo lato client
      // (soluzione più semplice senza bisogno di indici compositi)
      const newsRef = collection(db, 'news');
      const snapshot = await getDocs(newsRef);

      let allNews = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      // Filtra solo le news attive (non scadute)
      const activeNews = allNews.filter(item => {
        // Se non ha tempoFino, è sempre attiva
        if (!item.tempoFino) return true;

        // Converti il timestamp Firestore in Date
        const expiryDate = item.tempoFino.toDate();

        // La news è attiva solo se la data di scadenza è >= ora attuale
        return expiryDate >= now;
      });

      // Ordina per dataInserimento decrescente (più recenti prima)
      const sortedNews = activeNews.sort((a, b) => {
        const dateA = a.dataInserimento?.toDate() || new Date(0);
        const dateB = b.dataInserimento?.toDate() || new Date(0);
        return dateB - dateA;
      });

      setNews(sortedNews);
    } catch (err) {
      console.error('Errore caricamento news pubbliche:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return '';
    try {
      const date = timestamp.toDate();
      return date.toLocaleDateString('it-IT', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return '';
    }
  };

  const isExpiringSoon = (tempoFino) => {
    if (!tempoFino) return false;
    const expiryDate = tempoFino.toDate();
    const now = new Date();
    const hoursUntilExpiry = (expiryDate - now) / (1000 * 60 * 60);
    return hoursUntilExpiry > 0 && hoursUntilExpiry <= 48; // Scade entro 48 ore
  };

  const expiringSoonCount = useMemo(
    () => news.filter((item) => isExpiringSoon(item.tempoFino)).length,
    [news]
  );

  if (loading) {
    return (
      <div className="container py-5">
        <div className="card brand-card border-0 shadow-sm">
          <div className="card-body d-flex flex-column justify-content-center align-items-center text-center py-5" style={{ minHeight: '50vh' }}>
            <div className="spinner-border text-brand-secondary mb-3" role="status">
              <span className="visually-hidden">Caricamento news...</span>
            </div>
            <h3 className="brand-title mb-2">Stiamo caricando le news</h3>
            <p className="text-muted-brand mb-0">Recuperiamo gli ultimi aggiornamenti disponibili.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className=" border-0 shadow-sm mb-4 overflow-hidden">
        <div className="card-header brand-header border-0 py-4">
          <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
            <div>
              <h1 className="mb-3 fw-bold text-center text-brand-secondary" style={{
                fontFamily: "'Cinzel Decorative'",
                textShadow: '1px 1px 2px rgba(0, 0, 0)'
              }}>faNtaNews
              </h1>
            </div>
          </div>
        </div>
      </div>

      {news.length === 0 ? (
        <div className="border-0 shadow-sm">
          <div className="card-body text-center py-5">
            <div
              className="mx-auto mb-3 d-inline-flex align-items-center justify-content-center rounded-circle"
              style={{ width: '72px', height: '72px', background: 'rgba(194, 157, 84, 0.14)' }}
            >
              <i className="bi bi-newspaper fs-2 text-brand-secondary"></i>
            </div>
            <h4 className="brand-title mb-2">Nessuna news disponibile</h4>
            <p className="text-muted-brand mb-0">Torna a trovarci presto per le ultime novità.</p>
          </div>
        </div>
      ) : (
        <div className="row justify-content-center">
          <div className="col-12 col-xl-10">
            {news.map((item, index) => (
              <div key={item.id}>
                <article className="mb-4 overflow-hidden">
                  {item.imageUrl && (
                    <img
                      src={item.imageUrl}
                      className="card-img-top"
                      alt={item.titolo}
                      style={{ maxHeight: '420px', objectFit: 'cover' }}
                      onError={(e) => e.target.style.display = 'none'}
                    />
                  )}
                  <div className="p-4 p-lg-5">
                    <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-start gap-3 mb-3">
                      <div>
                        <h3 className="brand-title mb-2">{item.titolo}</h3>
                      </div>
                    </div>

                    <FormattedNewsText
                      as="p"
                      text={item.descrizione}
                      className="card-text mt-3 text-light mb-0 news-rich-text"
                      style={{ lineHeight: '1.75' }}
                    />

                    
                                        {item.link && (
                                          <div className="mt-4 d-flex flex-wrap justify-content-end gap-2">
                                            {item.link.startsWith('/') ? (
                                              <Link to={item.link} className="btn btn-brand-secondary">
                                                <i className="bi bi-arrow-right-circle me-2"></i>
                                                Scopri di più
                                              </Link>
                                            ) : (
                                              <a
                                                href={item.link}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-outline-brand-secondary"
                                              >
                                                <i className="bi bi-box-arrow-up-right me-2"></i>
                                                Vai al link
                                              </a>
                                            )}
                                          </div>
                                        )}

                    {item.dataInserimento && (
                      <div className={`mt-4 p-3 rounded-3 bg-brand-primary-light`}>
                        <small className="text-muted-brand d-flex align-items-center gap-1">
                          <i className="bi bi-clock-history me-2"></i>
                          {formatDate(item.dataInserimento)}
                        </small>
                      </div>
                    )}
                  </div>
                </article>

                {index < news.length - 1 && (
                  <div className="d-flex justify-content-center my-4">
                    <div style={{ width: '140px', height: '2px', background: 'linear-gradient(90deg, transparent, var(--brand-secondary), transparent)' }} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      <SectionAd placement="general" className="d-flex justify-content-center my-2" />
    </div>
  );
}
